import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { DeliveryPointDetails } from '../types/delivery-point-details.type';
import { ADMIN_DELIVERY_POINTS_API_PATHS } from '../constants/delivery-points-api-paths.constants';

type UseArchiveDeliveryPointResult = {
  archiveDeliveryPoint: (deliveryPointId: string) => Promise<DeliveryPointDetails | null>;
  isSubmitting: boolean;
};

export function useArchiveDeliveryPoint(): UseArchiveDeliveryPointResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const archiveDeliveryPoint = async (deliveryPointId: string): Promise<DeliveryPointDetails | null> => {
    setIsSubmitting(true);

    try {
      const archivedDeliveryPoint = await HttpClient.delete<DeliveryPointDetails>(
        ADMIN_DELIVERY_POINTS_API_PATHS.ARCHIVE_DELIVERY_POINT(deliveryPointId)
      );

      enqueueSnackbar('Point de livraison archivé', { variant: 'success' });
      return archivedDeliveryPoint;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de l'archivage du point de livraison"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { archiveDeliveryPoint, isSubmitting };
}
